import { render, staticRenderFns } from "./Word.vue?vue&type=template&id=fe223998&scoped=true&"
import script from "./Word.ts?vue&type=script&lang=ts&"
export * from "./Word.ts?vue&type=script&lang=ts&"
import style0 from "./Word.css?vue&type=style&index=0&id=fe223998&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe223998",
  null
  
)

export default component.exports